module.exports = __webpack_public_path__ + "img/id_back.fe0c914.png";